export const DEFAULT_ASSISTANT_STARTERS = [
  'This month, where is engineering investment most concentrated?',
  'Show the AI leverage trend this year.',
  'Which developers contributed the most REV this quarter?',
  'What is our average developer hourly cost in USD?',
  'Which repositories have the biggest delivery risk right now?',
  'How has developer retention changed over the past year?',
  'Compare engineering effort across our projects this quarter.',
  'Show me where I can review developer contribution details.',
  'Which teams are getting the most value from AI?',
  'What changed in our engineering productivity this month?'
];

export const MINI_ASSISTANT_SESSION_STORAGE_KEY =
  'gitme-ai-assistant-mini-session-id';

export const extractAssistantData = response =>
  response?.data || response || {};

export const getAssistantMessageEndpoint = sessionId =>
  sessionId
    ? `/ai-assistant/sessions/${encodeURIComponent(sessionId)}/messages`
    : '/ai-assistant/sessions/messages';

export const makeAssistantUserMessage = content => ({
  id: `temp-${Date.now()}`,
  role: 'user',
  content,
  createdAt: new Date().toISOString()
});

export const makeAssistantMessage = payload => ({
  id: payload.messageId || payload.id || `assistant-${Date.now()}`,
  role: 'assistant',
  content: payload.answer || payload.content || '',
  answer: payload.answer || payload.content || '',
  artifacts: Array.isArray(payload.artifacts) ? payload.artifacts : [],
  screens: Array.isArray(payload.screens) ? payload.screens : [],
  toolCalls: Array.isArray(payload.toolCalls) ? payload.toolCalls : [],
  starters: Array.isArray(payload.starters) ? payload.starters : [],
  pendingAction: payload.pendingAction || null,
  pendingApprovals: Array.isArray(payload.pendingApprovals)
    ? payload.pendingApprovals
    : [],
  pendingPlan: payload.pendingPlan || null,
  generatedAt: payload.generatedAt || new Date().toISOString()
});

export const mergeAssistantStarters = (...starterGroups) =>
  starterGroups
    .flat()
    .map(starter => String(starter || '').trim())
    .filter(Boolean)
    .filter((starter, index, all) => all.indexOf(starter) === index);
